import PublicMainFooter from "components/footers/PublicMainFooter";
import PublicMainNav from "components/navigations/PublicMainNav";
import React from "react";
import { Outlet } from "react-router-dom";

export default function PublicUserFilter() {
  return (
    <div>
      <PublicMainNav />
      <Outlet />
      <PublicMainFooter />
    </div>
  );
}
